module.exports = __webpack_public_path__ + "static/media/logo_siste_gestion_calidad.ced8c220.jpg";